import { useSelector } from 'react-redux';
import { routeParamsSelector } from '../../CommonComponents/Router/Selector';
import { useIsWorkflow, useStateParams } from '../state/selectors';
import { ProviderType } from '../DocumentVault.meta';

interface SelectRouteParams {
  clientId: string;
  path: string;
  providerType: ProviderType;
  filterableByYear: string;
  previousComponent?: string;
}

export interface RouteParams extends Omit<SelectRouteParams, 'filterableByYear'> {
  clientId: string;
  path: string;
  providerType: ProviderType;
  filterableByYear: boolean;
}

export const useRouteParams = (): RouteParams => {
  const { filterableByYear, ...params } = useSelector(routeParamsSelector) as SelectRouteParams;

  const isInWorkflow = useIsWorkflow();

  const stateParams = useStateParams();

  /**
   * When we are inside the comprehensive workflow, we cannot use the URL to keep
   * the context (clientId, path and provider type). In that case, we need
   * to use the Redux store.
   */
  if (isInWorkflow) {
    return {
      clientId: params.clientId,
      ...stateParams,
    };
  }

  return {
    ...params,
    providerType: +params.providerType,
    filterableByYear: filterableByYear === 'true',
  };
};
